export const configFlightHistoryDh = {
  "data": {
    "Type": "GeoJSON",
    "cache_busting": true,
    "retain": true
  }
};

export const configFlightHistoryTrackPointLayer = {
  "Name": "trackPoint",
  "Renderer": "GeoJSONExt",
  "Attributes": {
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "point",
          "value": true
        },
        "style": {
          "default": {
            "type": "point",
            "point_size": 10,
            "line_color": "#000000",
            "point_color": "#FFFFFF"
          }
        }
      }
    ]
  }
}

export const configFlightHistoryTrackLineLayer = {
  "Name": "trackLine",
  "Renderer": "TrackLine",
  "Attributes": {
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "gradation",
          "value": true
        },
        "style": {
          "default": {
            "type": "line",
            "line_method": "GC",
            "line_width": 6,
            "option": "bevel",
            "gradation": [
              {alt: 53000, 'color': 'rgba(106,27,154, 0.8)'},
              {alt: 5000, 'color': 'rgba(0, 0, 128, 0.8)'},
              {alt: 3000, 'color': 'rgba(21, 101, 192, 0.8)'},
              {alt: 2000, 'color': 'rgba(0, 131, 143, 0.8)'},
              {alt: 1000, 'color': 'rgba(0, 128, 0, 0.8)'},
              {alt: 700, 'color': 'rgba(158, 157, 36, 0.8)'},
              {alt: 500, 'color': 'rgba(249, 168, 37, 0.8)'},
              {alt: 300, 'color': 'rgba(239, 108, 0, 0.8)'},
              {alt: 200, 'color': 'rgba(198, 40, 40, 0.8)'},
              {alt: 100, 'color': 'rgba(128, 0, 0, 0.8)'}
            ]
          }
        }
      }
    ]
  }
}
